import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from 'reactstrap';
import { TranslationsKeys } from '../../../../../../locales/translations';

interface openModalProps {
  formData: any;
  id?: string;
}

interface Props {
  onConfirm: ({ formData, id }: openModalProps) => void;
  onDecline: () => void;
}

export interface ConfirmModalRef {
  openModal: ({ formData, id }: openModalProps) => void;
  closeModal: () => void;
}

const ConfirmModal = forwardRef<ConfirmModalRef, Props>(
  ({ onConfirm, onDecline }, ref) => {
    const { t } = useTranslation(TranslationsKeys.MANAGEMENT_TOOLS_SURVEY);
    const [data, setData] = useState<any>(null);
    const [id, setId] = useState<string | null>(null);

    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal({ formData, id: surveyId }) {
        setData(formData);
        setId(surveyId || null);
        setModal(true);
      },
      closeModal() {
        setData(null);
        setId(null);
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <Container fluid className="text-center">
          <Icon name="information" size={45} />
          <p className="text-dark fs-22 mt-3 mb-4">
            {t('surveyCreation.creationModal.title')}
          </p>
          <p className="text-dark fs-18 mt-3 mb-4">
            {t('surveyCreation.creationModal.description')}
          </p>
          <div className="d-flex justify-content-around" style={{ gap: 10 }}>
            <div className="flex-fill">
              <Button
                className="w-100"
                outlined
                text={t('surveyCreation.creationModal.back')}
                onClick={() => {
                  onDecline();
                  setModal(false);
                }}
              />
            </div>
            <div className="flex-fill">
              <Button
                className="w-100"
                text={t('surveyCreation.creationModal.confirm')}
                onClick={() => {
                  onConfirm({ formData: data, id: id || undefined });
                  setModal(false);
                }}
              />
            </div>
          </div>
        </Container>
      </Modal>
    );
  },
);

export default ConfirmModal;
